import { useEffect, useState } from "react";

export default function ThreeDSZidpayFrame ({ threeDSUrl, onRedirect }) {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    function handleMessage (event) {
      if (!event.data) return;

      try {
        const message = JSON.parse(event.data);
        if (message.sender === "MF-3DSecure") {
          const { url } = message;
          setIsOpen(false);
          if (onRedirect) {
            onRedirect(url);
          } else {
            window.location.href = url; // fallback
          }
        }
      } catch (err) {
        // ignore wrong messages
      }
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [onRedirect]);

  if (!isOpen) return null;

  return (
    <iframe
      src={threeDSUrl}
      style={{
        width: "100%",
        height: "600px",
        border: "none"
      }}
      allow="fullscreen"
    />
  );
}
